import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "modal-container show" }
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "loading-pulse" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "blocker" }, null, -1)
const _hoisted_6 = {
  class: "modal",
  style: {"width":"1020px"}
}
const _hoisted_7 = { class: "modal__content pa-1" }
const _hoisted_8 = { class: "stepper--bar" }
const _hoisted_9 = { class: "stepper--bar__header" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "1", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Upload IP File", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "2", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Enrich Lead", -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title-count" }, "3", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__header--title" }, "Submit", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "pa--y-1 pa--left-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("Manual Upload"),
  /*#__PURE__*/_createElementVNode("span", {
    class: "text--style-italic",
    style: {"font-size":"80%"}
  })
], -1)
const _hoisted_21 = { class: "form-field form-field__standard ma--top-1" }
const _hoisted_22 = { class: "form-field__control" }
const _hoisted_23 = {
  type: "file",
  class: "form-field__input",
  ref: "upload"
}
const _hoisted_24 = { style: {"font-size":"80%"} }
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"80%"} }, "Template screenshot(below)", -1)
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "stepper--bar__content" }
const _hoisted_29 = { class: "pa--y-1 pa--left-1" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  class: "text--style-italic",
  style: {"font-size":"80%"}
}, null, -1)
const _hoisted_32 = { class: "form-checkbox" }
const _hoisted_33 = ["id", "onClick"]
const _hoisted_34 = ["for"]
const _hoisted_35 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_36 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"100%","height":"0"} }, null, -1)
const _hoisted_38 = { style: {"width":"100%"} }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h4", { style: {"display":"inline-block"} }, "Premium Data", -1)
const _hoisted_40 = {
  key: 0,
  class: "form-checkbox",
  style: {"display":"inline-block","min-width":"0","margin-left":"10px"}
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  style: {"font-size":"small","color":"gray"},
  for: "selectAllFields"
}, "Select All", -1)
const _hoisted_42 = {
  key: 0,
  class: "pa--x-0 pa--bottom-1 col-3"
}
const _hoisted_43 = { class: "form-checkbox" }
const _hoisted_44 = ["id", "checked", "onClick", "disabled"]
const _hoisted_45 = ["for"]
const _hoisted_46 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_47 = {
  key: 1,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_48 = {
  key: 1,
  class: "stepper--bar__content--label__info--error"
}
const _hoisted_49 = { class: "stepper--bar__content--label__info" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "stepper--bar__content--label__info--message pa-1" }, [
  /*#__PURE__*/_createTextVNode(" Data To Be Enriched "),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__content--label__info--message__data" })
], -1)
const _hoisted_51 = { class: "row stepper--bar__content--label__info--message justify--flex-start pa-1" }
const _hoisted_52 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_53 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_54 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_55 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_56 = { class: "row stepper--bar__content--label__info--message justify--flex-start pa-1" }
const _hoisted_57 = {
  key: 0,
  class: "text--style-italic",
  style: {"font-size":"80%"}
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "stepper--bar__content--label__info--message pa-1" }, [
  /*#__PURE__*/_createTextVNode(" No of IP's for processing "),
  /*#__PURE__*/_createElementVNode("span", { class: "stepper--bar__content--label__info--message__data" }, " Will be shown on processing. ")
], -1)
const _hoisted_59 = { class: "stepper--bar__content--label__info--message pa-1" }
const _hoisted_60 = { class: "stepper--bar__content--label__info--message__data" }
const _hoisted_61 = {
  key: 0,
  class: "stepper--bar__content--label__info--error pa-1"
}
const _hoisted_62 = { class: "modal__footer" }
const _hoisted_63 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 1,
                })
              }, _hoisted_12, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 2,
                })
              }, _hoisted_15, 2),
              _createElementVNode("li", {
                class: _normalizeClass({
                  active: _ctx.stepper == 3,
                })
              }, _hoisted_18, 2)
            ])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-1", {
                'label--active': _ctx.stepper == 1,
              }])
          }, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("input", _hoisted_23, null, 512)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("a", {
                  href: _ctx.templateUrl,
                  download: "template.csv"
                }, "Download Template", 8, _hoisted_25)
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("img", { src: _ctx.templateImage }, null, 8, _hoisted_27)
              ])
            ])
          ], 2),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-2", {
                'label--active': _ctx.stepper == 2,
              }])
            }, [
              _createElementVNode("div", _hoisted_29, [
                (!_ctx.subscriptionMode)
                  ? (_openBlock(), _createElementBlock("h4", _hoisted_30, [
                      _createTextVNode("Included Data"),
                      _hoisted_31
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["row form-group--checkbox", { 'pa--y-2': _ctx.subscriptionMode }])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (
                        item.leadFieldName != 'middleName' &&
                        item.leadFieldName != 'lastName' &&
                        item.credit == 0 ||
                        item.leadFieldName == 'email' ||
                        item.leadFieldName == 'city'
                      )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["pa--x-0 pa--bottom-1", {
                        'col-6': item.leadFieldName == 'firstName',
                        'col-3': item.leadFieldName != 'firstName',
                      }])
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("input", {
                                id: 'field-' + index,
                                type: "checkbox",
                                checked: true,
                                onClick: ($event: any) => (item.value = !item.value),
                                disabled: true
                              }, null, 8, _hoisted_33),
                              _createElementVNode("label", {
                                for: 'field-' + index
                              }, [
                                _createTextVNode(_toDisplayString(item.leadFieldName == "firstName"
                                ? "First Name, Middle Initial & Last Name"
                                : item.displayName) + " ", 1),
                                (!_ctx.subscriptionMode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item.leadFieldName != 'email')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "(Free)"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_36, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credit)) + ")", 1))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_34)
                            ])
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128)),
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    (!_ctx.subscriptionMode)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("input", {
                            id: "selectAllFields",
                            type: "checkbox",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectAllFields && _ctx.selectAllFields(...args)))
                          }),
                          _hoisted_41
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      (
                        item.credit > 0 &&
                        item.leadFieldName != 'email' &&
                        item.leadFieldName != 'city'
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("input", {
                                id: 'field-' + index,
                                type: "checkbox",
                                checked: item.value,
                                onClick: ($event: any) => (item.value = !item.value),
                                disabled: item.disabled
                              }, null, 8, _hoisted_44),
                              _createElementVNode("label", {
                                for: 'field-' + index
                              }, [
                                _createTextVNode(_toDisplayString(item.leadFieldName == "firstName"
                                ? "Full Name"
                                : item.displayName) + " ", 1),
                                (!_ctx.subscriptionMode)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item.credit > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_46, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credit)) + ")", 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_47, "(Free)"))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_45)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ], 2),
                (_ctx.fieldsError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, " Please select at least one parameter "))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["stepper--bar__content--label stepper--bar__content--label-3", {
                'label--active': _ctx.stepper == 3,
              }])
            }, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedFields, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-3 pa--bottom-1 stepper--bar__content--label__info--message__fields"
                    }, _toDisplayString(index + 1) + ". " + _toDisplayString(item.displayName), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createTextVNode(" Base Data (Email Address) "),
                  _createElementVNode("span", _hoisted_53, " $ " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.emailCreditsForField)), 1)
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createTextVNode(" Premium Data "),
                  _createElementVNode("span", _hoisted_55, " $ " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.selectedPremiumFieldTotalCredits)), 1)
                ]),
                _createElementVNode("div", _hoisted_56, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPremiumFields(), (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "col-3 pa--bottom-1 stepper--bar__content--label__info--message__fields"
                    }, [
                      _createTextVNode(_toDisplayString(index + 1) + ". " + _toDisplayString(item.displayName) + " ", 1),
                      (!_ctx.subscriptionMode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, "($ " + _toDisplayString(_ctx.formatNumber2Decimals(item.credits)) + ")", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _hoisted_58,
                _createElementVNode("div", _hoisted_59, [
                  _createTextVNode(" Total Credits per IP "),
                  _createElementVNode("span", _hoisted_60, " $ " + _toDisplayString(_ctx.formatNumber2Decimals(_ctx.response)), 1)
                ]),
                (_ctx.insufficentCredits)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      _createTextVNode(" You don't have enough credits, "),
                      _createElementVNode("a", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.buyCredits && _ctx.buyCredits(...args)))
                      }, " Buy Credits ")
                    ]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_62, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn--secontary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, " Cancel "),
        (_ctx.stepper != 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn--secontary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backToFields && _ctx.backToFields(...args)))
            }, " Back "))
          : _createCommentVNode("", true),
        (_ctx.stepper == 1 ||_ctx.stepper == 2)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.proceed2 && _ctx.proceed2(...args))),
              disabled: !_ctx.subscriptionMode && !_ctx.fields.some((f) => !f.disabled)
            }, " Proceed ", 8, _hoisted_63))
          : (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "btn btn--primary",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.purchaseLeads2 && _ctx.purchaseLeads2(...args)))
            }, " Purchase "))
      ])
    ])
  ]))
}